// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"836":"0bb3aeeb","932":"41dce0e8"}[chunkId] + ".chunk.css";
};